import React, { } from 'react';
import { Box } from "@material-ui/core"
import { useMediaQuery } from 'react-responsive';
import { useStyles } from '../styles/index.style';
import {useDigitalPR} from '../hooks/useDigitalPR';
import TableFilters from './TableFilters';
import TableActions from './TableActions';
import PRTable from './PRTable';
import AppliedFilters from './AppliedFilters';

const PRTableWrapper = () => {
   const classes = useStyles();
   const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
   const { currentFilters, onCampaignFiltersChange } = useDigitalPR();

   return (
      <Box className={isPhone ? '' : classes.wrapper}>
         <Box className={isPhone ? '' : classes.card}>
            <Box className={isPhone ? '' : classes.card__wrapper}>
               <Box display="flex" flexWrap="wrap" justifyContent="space-between">
                  {!isPhone && (<Box className={classes.card_title}>Digital PR</Box>)}
                  <TableActions onFilterChange={onCampaignFiltersChange} />
               </Box>                
               <AppliedFilters />
               <TableFilters filters={currentFilters} onFilterChange={onCampaignFiltersChange}  />
               <PRTable />
            </Box>
         </Box>
      </Box>
   )
}

export default PRTableWrapper;